"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class SignUpMapper {
    toDomain(result) {
        const hasError = !!lodash_1.default.get(result, "errors");
        const isLoading = lodash_1.default.get(result, "loading");
        const userId = lodash_1.default.get(result, "data.signupV2.id");
        return {
            hasError,
            isLoading,
            userId
        };
    }
}
exports.SignUpMapper = SignUpMapper;
